import { Message } from 'element-ui'
import axios from 'axios'
import Cookies from 'js-cookie'

// 创建axios实例
const service = axios.create({
  withCredentials: true,
  timeout: 50000, // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  config.headers = { 'Accept-Language':Cookies.get('language') }
  return config
}, error => {
  // Do something with request error
  console.log(error)// for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    //统一异常处理
    if (response && response.data) {
      const data = response.data
      //未登录则重定向
      if (data.errorCode === '302') { //清除session,返回到登录
        window.location.href = data.result
      } else {
        if (typeof (data.success) !== 'undefined' && !data.success) {
          if (typeof (data.hasBusinessException) !== 'undefined' && !data.hasBusinessException) {
            Message({
              message: '系统异常：' + (typeof (data.requestId) === 'undefined' ? '' : data.requestId),
              type: 'error',
              showClose: true
            })
          } else {
            Message({
              message: data.message,
              type: 'error',
              duration: 3 * 1000,
              showClose: true
            })
          }
        }
      }
      return Promise.resolve(response.data)
    } else {
      return Promise.reject()
    }
  },
  error => {
    console.log('err' + error)// for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000,
      showClose: true
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/util/fetch.js